const FROM_ARABIC_NUMBER_MAP = {
  '٠': '0',
  '١': '1',
  '٢': '2',
  '٣': '3',
  '٤': '4',
  '٥': '5',
  '٦': '6',
  '٧': '7',
  '٨': '8',
  '٩': '9',
}
const TO_ARABIC_NUMBER_MAP = {
  0: '٠',
  1: '١',
  2: '٢',
  3: '٣',
  4: '٤',
  5: '٥',
  6: '٦',
  7: '٧',
  8: '٨',
  9: '٩',
}

const convertArabicNumerals = (number) => {
  const convertedResult =
    number &&
    String(number)
      .split('')
      .map((c) => FROM_ARABIC_NUMBER_MAP[c] || c)
      .join('')

  return convertedResult || ''
}

const convertToArabicNumerals = (number) => {
  const convertedResult =
    number &&
    String(number)
      .split('')
      .map((n) => TO_ARABIC_NUMBER_MAP[n] || n)
      .join('')

  return convertedResult || ''
}

export { convertArabicNumerals, convertToArabicNumerals }
